var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('folder-list',{attrs:{"documents":_vm.documents,"user":_vm.visit.user.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }